export default __webpack_public_path__ + "static/bagnard-webfont-41ca9eef63433534aadddb139f594a84.woff2";